export const ROUTING_OPTIONS = ["k1", "k2", "k5", "rerouting"];
const CRITICAL_FACILITIES_OPTIONS = ["min", "max"];
const DEFAULT_DEPARTURE_TIMES_CONFIG = "departure_times";

export function defaultRunName(existingNames = []) {
  let nextNumber = 1;
  for (const name of existingNames) {
    const match = /^New Run \(([1-9]\d*)\)$/.exec(String(name));
    const number = Number(match?.[1]);
    if (Number.isSafeInteger(number)) nextNumber = Math.max(nextNumber, number + 1);
  }
  return `New Run (${nextNumber})`;
}

export function normalizeRun(docSnap) {
  const data = docSnap.data() || {};
  const createdAtFromTs =
    data?.createdAt && typeof data.createdAt?.toMillis === "function"
      ? data.createdAt.toMillis()
      : 0;
  const createdAtMs = Number.isFinite(Number(data.createdAtMs))
    ? Number(data.createdAtMs)
    : createdAtFromTs;

  const routingRaw = String(data.routingStrategy || data.routing_strat || data.routing_strategy || "k1").toLowerCase();
  const routingStrategy = ROUTING_OPTIONS.includes(routingRaw) ? routingRaw : "k1";
  const runLayers = data?.runLayers || data?.run_layers || {};
  const destinationConfigName = String(
    runLayers?.destinationConfigName ||
      runLayers?.destinationConfig ||
      runLayers?.destination_config ||
      data?.destinationConfigName ||
      data?.destination_config ||
      "destinations"
  );
  const departureTimesConfigName = String(
    runLayers?.departureTimesConfigName ||
      runLayers?.departure_times_config ||
      runLayers?.departureTimes ||
      runLayers?.departure_times ||
      data?.departureTimesConfigName ||
      data?.departure_times_config ||
      data?.departure_times ||
      DEFAULT_DEPARTURE_TIMES_CONFIG
  );
  const criticalFacilitiesRaw = String(
    runLayers?.criticalFacilities ||
      runLayers?.critical_facilities ||
      data?.criticalFacilities ||
      data?.critical_facilities ||
      "min"
  ).toLowerCase();
  const criticalFacilities = CRITICAL_FACILITIES_OPTIONS.includes(criticalFacilitiesRaw)
    ? criticalFacilitiesRaw
    : "min";
  const hazardConfigName = String(
    runLayers?.hazardConfigName ||
      runLayers?.hazard_config ||
      data?.hazardConfigName ||
      data?.hazard_config ||
      ""
  );
  const contraflowConfigName = String(
    runLayers?.contraflowConfigName ||
      runLayers?.contraflow_config ||
      data?.contraflowConfigName ||
      data?.contraflow_config ||
      ""
  );

  const blockedRoadConfigName = String(runLayers?.blockedRoadConfigName || runLayers?.blocked_road_config || data?.blockedRoadConfigName || data?.blocked_road_config || "");

  return {
    id: docSnap.id,
    name: String(data.name || `Run ${docSnap.id.slice(0, 6)}`),
    vehiclesPerHousehold: data.vehiclesPerHousehold != null && Number.isFinite(Number(data.vehiclesPerHousehold))
      ? Number(data.vehiclesPerHousehold)
      : 1,
    randomSeed: Number.isFinite(Number(data.randomSeed))
      ? Number(data.randomSeed)
      : Number.isFinite(Number(data.random_seed))
      ? Number(data.random_seed)
      : 42,
    routingStrategy,
    status: String(data.status || "draft").toLowerCase(),
    createdAtMs,
    runLayers: {
      linksLayerId: String(runLayers?.linksLayerId || runLayers?.links_layer_id || ""),
      nodesLayerId: String(runLayers?.nodesLayerId || runLayers?.nodes_layer_id || ""),
      parcelsLayerId: String(runLayers?.parcelsLayerId || runLayers?.parcels_layer_id || ""),
      linksFileName: String(runLayers?.linksFileName || runLayers?.links || "berkeley_links.csv"),
      nodesFileName: String(runLayers?.nodesFileName || runLayers?.nodes || "berkeley_nodes.csv"),
      parcelsFileName: String(runLayers?.parcelsFileName || runLayers?.parcels || "berkeley_parcels.csv"),
      destinationConfigName,
      departureTimesConfigName,
      criticalFacilities,
      hazardLayerId: String(
        runLayers?.hazardLayerId ||
        runLayers?.hazard_layer_id ||
        runLayers?.hazardLayerIds?.[0] ||
        runLayers?.hazard_layer_ids?.[0] ||
        ""
      ),
      hazardLayerName: String(
        runLayers?.hazardLayerName ||
        runLayers?.hazard_layer_name ||
        runLayers?.hazardLayerNames?.[0] ||
        runLayers?.hazard_layer_names?.[0] ||
        ""
      ),
      hazardConfigName,
      contraflowConfigName,
      blockedRoadConfigName,
    },
  };
}

export function formatStatus(status) {
  if (status === "running") return "Running";
  if (status === "done" || status === "complete" || status === "completed") return "Done";
  return "Idle";
}

export function positiveNumber(...values) {
  for (const value of values) {
    const number = Number(value);
    if (Number.isFinite(number) && number > 0) return number;
  }
  return null;
}

export function mapRoutingForApi(strategy) {
  const normalized = String(strategy || "").toLowerCase();
  return ROUTING_OPTIONS.includes(normalized) ? normalized : "k1";
}

export function toNumberOrFallback(v, fallback) {
  const n = Number(v);
  return Number.isFinite(n) ? n : fallback;
}
